export default __webpack_public_path__ + "static/media/ATE_Loyalty_Program_Werbetrailer_sec22.e454a919.jpg";